import React, {Component} from 'react';
import CertificateDetails from './CertificateDetails';
import MetadataParameterItem from "./MetadataParameterItem";
import SloParameterItem from "./SloParameterItem";
import AcsParameterItem from "./AcsParameterItem";
import * as samlConstants from '../../../constants/samlConstants';

class ListOfParameters extends Component {

  render() {
    return (
        <div>
          <div className="entry-label">{this.props.label}</div>
          {this.props.list.length > 0 ? (
              <div className="entry-value">
                {
                  this.props.list.map(
                      (item, index) => {
                        switch (this.props.parameterName) {

                          case samlConstants.PUBLIC_KEY_CERTIFICATE_INFO:
                            return (<CertificateDetails
                                certificateDetails={item[this.props.parameterName]}
                                key={index}/>)

                          case samlConstants.SLO_ITEMS:
                            return (<SloParameterItem
                                location={item.location}
                                binding={item.binding}
                                responseLocation={item.responseLocation
                                    ? item.responseLocation : null}
                                key={index}/>)

                          case samlConstants.ACS_ITEMS:
                            return (<AcsParameterItem
                                key={index}
                                index={item.index}
                                location={item.location}
                                isDefault={item.isDefault}
                                binding={item.binding}/>)

                          default:
                            return (<MetadataParameterItem
                                isLocalized={this.props.isLocalized}
                                parameter={item[this.props.parameterName]}
                                key={index}/>)
                        }
                      }
                  )
                }
              </div>
          ) : (<div className="entry-value">{this.props.notSpecifiedText}</div>)
          }
        </div>
    );
  }
}

export default ListOfParameters;


// WEBPACK FOOTER //
// ./src/components/AddSAML/ViewAllMetadataPopup/ListOfParameters.js